import React from "react";
// import InvestLandingScreen from "./InvestLandingScreen";
// import InvestTermsConditionsDisclaimerScreen from "./InvestTermsConditionsDisclaimerScreen";
// import InvestSignupFormScreen from "./InvestSignupFormScreen";
// import InvestOptionsInfoScreen from "./InvestOptionsInfoScreen";
import InvestHomeScreen from "./InvestHomeScreen";
// import InvestSwitchInvestmentFormScreen from "./InvestSwitchInvestmentFormScreen";
// import InvestAddFundsScreen from "./InvestAddFundsScreen";
// import InvestWithdrawFundsScreen from "./InvestWithdrawFundsScreen";
// import SwitchInvestmentNotificationConfirmScreen from "./SwitchInvestmentNotificationConfirmScreen";
// import AddInvestmentNotificationConfirmScreen from "./AddInvestmentNotificationConfirmScreen";
// import InsufficientFundsNotificationScreen from "./InsufficientFundsNotificationScreen";
// import InvestBankingDetailsFormScreen from "./InvestBankingDetailsFormScreen";
// import KYCDisclaimerScreen from "./KYCDisclaimerScreen";
import InvestInfoScreen from "./InvestInfoScreen";
// import InvestKYCVerificationFailScreen from "./InvestKYCVerificationFailScreen";
// import InvestKYCVerificationPendingScreen from "./InvestKYCVerificationPendingScreen";
import { createStackNavigator } from "@react-navigation/stack";
// import InvestCloseAccountNotificationScreen from "./InvestCloseAccountNotification";
// import InvestDetailsScreen from "./InvestDetailsScreen";
// import InvestListReccuringScreen from "./InvestListReccuringScreen";
// import InvestConfirmReccuringCancelScreen from "./InvestConfirmReccuringCancelScreen";
// import InvestmentComplianceStepAScreen from "./InvestmentComplianceStepAScreen";
// import InvestmentComplianceStepBScreen from "./InvestmentComplianceStepBScreen";
import ManageFundScreen from "./ManageFundScreen"



const Stack = createStackNavigator();

export default function investNavigationStack() {
  return (
    <>
      <Stack.Screen
        name="InvestHome"
        component={InvestHomeScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="InvestInfo"
        component={InvestInfoScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="ManageFund"
        component={ManageFundScreen}
        options={{ headerShown: false }}
      />
    </>
  )
}